export const TASK_WIDTH = 170
export const TASK_HEIGHT = 50
export const HALF_TASK_WIDTH = TASK_WIDTH / 2
export const HALF_TASK_HEIGHT = TASK_HEIGHT / 2
export const TASK_BORDER_RADIUS = 5
export const TASK_SELECTED_BORDER_WIDTH = 2

export const FILE_EXTENSION = '.fz'
